// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__Vppb4","flexBoxBlk":"Navigation_flexBoxBlk__hQ0x0"};